import { useEffect, useState } from 'react'
//ui
import { Paper, SearchInput } from '../../../../ui/index'
import TooltipIcons from '../../../../../../pages/Reportes/TooltipIcons'
//assets
import StarFullIcon from '@mui/icons-material/StarOutlined'

// hooks
import { arrayIcons } from './dataIcon'
import { useContentTypeReportes } from '../../../../../../pages/Reportes/useReportes.hook'

const FavoriteNavBar = ({ setShowModal }) => {
  const styleImage = 'cursor-pointer w-8 h-8'
  const favoriteIcons = useContentTypeReportes(state => state.favoriteIcons)
  const removeFavoriteIcon = useContentTypeReportes(state => state.removeFavoriteIcon)
  const setFavoriteContent = useContentTypeReportes(state => state.setFavoriteContent)
  const resetTypeContent = useContentTypeReportes(state => state.resetTypeContent)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    resetTypeContent()
  }, [resetTypeContent])

  const handleIconClick = (icon) => {
    setFavoriteContent(icon.id)
    setShowModal(true)
  }

  const filteredIcons = searchTerm
    ? favoriteIcons.filter((icon) =>
        icon.title.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : favoriteIcons

    return (
      <div>
        <Paper>
          <section className="flex items-center justify-end p-4">
            <SearchInput
              placeholder="Buscar reporte"
              classNameBorder="rounded-full"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </section>
          <section className="grid grid-cols-[repeat(auto-fit,minmax(180px,1fr))] gap-6 py-4 max-w-screen-lg mx-auto place-items-center font-sans text-text">
            {filteredIcons.length > 0 ? (
              filteredIcons.map((icon, index) => (
                <div
                  key={index}
                  className="relative flex flex-col items-center justify-start shadow-md border rounded-2xl w-full max-w-[200px] aspect-square p-3 cursor-pointer font-sans"
                  onClick={() => handleIconClick(icon)}
                >
                  {icon.tooltip && (
                    <div className="absolute top-2 right-2">
                      <TooltipIcons tooltipText={icon.tooltip} />
                    </div>
                  )}
                  <div className="absolute top-2 left-2">
                    <StarFullIcon
                      className={styleImage}
                      style={{ color: "orange" }}
                      alt="icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeFavoriteIcon(icon.id);
                      }}
                    />
                  </div>
                  {/* Icon */}
              <div className="mt-5 text-primary text-[64px]">
                {arrayIcons.find(i => i.id === icon.id)?.icon}
              </div>
              
              {/* Title */}
              <p className="text-center text-[11px] sm:text-[12px] md:text-[13px] mt-3 font-semibold text-text leading-snug">
                {icon.title}
              </p>
                </div>
              ))
            ) : (
              <p className="text-center text-sm text-muted font-sans">
                No se encontraron reportes favoritos
              </p>
            )}
          </section>
        </Paper>
      </div>
    )
}

export default FavoriteNavBar
